import { BASE_URL } from '@constants/api'
import { RecurrentQuestionDetailsResponse } from '@models/RecurrentQuestions'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { setAuthorization } from '@utils/helpers'

export const reportApi = createApi({
	reducerPath: 'reportApi',
	baseQuery: fetchBaseQuery({
		baseUrl: BASE_URL,
		prepareHeaders: setAuthorization,
	}),
	endpoints: (builder) => ({
		getRecurrentQuestionDetails: builder.query<
			RecurrentQuestionDetailsResponse,
			{ disciplineId: number; juryId?: number; yearId?: number }
		>({
			query: ({ disciplineId, juryId, yearId }) => ({
				url: `/recurrent-question/details`,
				method: 'GET',
				params: { disciplineId, juryId, yearId },
			}),
		}),
	}),
})

export const { useGetRecurrentQuestionDetailsQuery } = reportApi
